import Channels from "discourse/plugins/chat/discourse/components/chat/routes/channels";

export default <template><Channels /></template>
